import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { Match } from '../api/types';
import { flagOf } from '../lib/teams';

export default function LiveBanner() {
  const { data } = useQuery({
    queryKey: ['live-matches'],
    queryFn: async () => (await api.get<Match[]>('/matches/live')).data,
    refetchInterval: 30_000,
  });

  if (!data || data.length === 0) return null;

  return (
    <div className="bg-red-600 text-white">
      <div className="max-w-5xl mx-auto px-3 py-2 flex flex-wrap gap-x-3 gap-y-1 items-center text-xs sm:text-sm">
        <span className="font-bold animate-pulse">🔴 AO VIVO</span>
        {data.map((m) => (
          <span key={m.id} className="whitespace-nowrap">
            {flagOf(m.team_home)} <strong>{m.score_home ?? 0}</strong> ×{' '}
            <strong>{m.score_away ?? 0}</strong> {flagOf(m.team_away)}
          </span>
        ))}
      </div>
    </div>
  );
}
